import { subDays, startOfDay, endOfDay } from "date-fns";
import { getEndOfValidDate } from "@/lib/utilFunctions";
import { PERFORMANCE_DEFINITION } from "@/misc/desktopCharts";
import getPerformanceData from "@/api/usageAndPerformance";

const definition = {
  withoutVirtusize: {},
  sizeRecommendations: {},
  clicks: {},
  comparisons: {},
};

const state = {
  selectedDateRange: null,
  activeViewName: PERFORMANCE_DEFINITION[0].name,
  activeChartContentName: PERFORMANCE_DEFINITION[0].content[0].name,
  performanceData: {
    purchaseShare: { ...definition },
    saleShare: { ...definition },
    conversionRate: { ...definition },
  },
};

const getters = {
  selectedDateRange: (state) => state.selectedDateRange,
  getActiveViewName: (state) => state.activeViewName,
  getActiveChartContentName: (state) => state.activeChartContentName,
  getPerformanceData: (state) => state.performanceData,
};

const actions = {
  initDateRange({ dispatch }) {
    const endOfValidDate = getEndOfValidDate();
    dispatch("setDateRange", {
      startDate: startOfDay(subDays(endOfValidDate, 30)),
      endDate: startOfDay(endOfValidDate),
    });
  },
  setDateRange({ commit, dispatch }, payload) {
    commit("setDateRange", payload);
    dispatch("fetchAllPerformance");
  },
  fetchAllPerformance({ dispatch, state }) {
    if (!state.selectedDateRange) {
      return;
    }
    PERFORMANCE_DEFINITION.forEach((view) => {
      view.content.forEach((definition) => {
        dispatch("fetchPerformance", { view: view.name, name: definition.name });
      });
    });
  },
  async fetchPerformance({ commit, rootGetters, state }, payload) {
    const { view, name } = payload;
    const startDate = startOfDay(subDays(state.selectedDateRange.startDate, 1));
    const endDate = endOfDay(subDays(state.selectedDateRange.endDate, 1));
    const currentStore = rootGetters["user/getCurrentStore"];
    const filters = rootGetters["filters/getAllActiveFilters"];
    const showOnlyUniqueUsers = rootGetters["filters/getShowOnlyUniqueUsers"];
    commit("setLoadingStatus", {
      view,
      name,
      loadingStatus: true,
    });
    try {
      let performanceChartData = await getPerformanceData({
        view,
        name,
        storeId: currentStore.store_id,
        startDate,
        endDate,
        filters,
        showOnlyUniqueUsers,
        page: "performance",
      });
      commit("setPerformance", {
        view,
        name,
        performanceChartData,
      });
    } catch (e) {
      commit("setPerformanceError", {
        view,
        name,
      });
    } finally {
      commit("setLoadingStatus", {
        view,
        name,
        loadingStatus: false,
      });
    }
  },
};

const mutations = {
  setDateRange(state, payload) {
    const { startDate, endDate } = payload;
    state.selectedDateRange = { startDate, endDate };
  },
  setActiveViewName(state, payload) {
    state.activeViewName = payload;
  },
  setActiveChartContentName(state, payload) {
    state.activeChartContentName = payload;
  },
  setLoadingStatus(state, payload) {
    const { view, name, loadingStatus } = payload;
    state.performanceData = {
      ...state.performanceData,
      [view]: {
        ...state.performanceData[view],
        [name]: {
          ...state.performanceData[view][name],
          isLoading: loadingStatus,
        },
      },
    };
  },
  setPerformance(state, payload) {
    const { view, name, performanceChartData } = payload;
    state.performanceData = {
      ...state.performanceData,
      [view]: {
        ...state.performanceData[view],
        [name]: {
          ...state.performanceData[view][name],
          ...performanceChartData,
          isError: false,
        },
      },
    };
  },
  setPerformanceError(state, payload) {
    const { view, name } = payload;
    state.performanceData = {
      ...state.performanceData,
      [view]: {
        ...state.performanceData[view],
        [name]: {
          ...state.performanceData[view][name],
          isError: true,
        },
      },
    };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
